import { useEffect, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { goBack } from '../../utils/appBridge'
import { useBottomSheet } from '../../state-management/contexts/BottomSheetContext'
import { useMFExecutionContext } from '../../state-management/contexts/MFExecutionContext'
import { useMetaDataContext } from '../../state-management/contexts/MetaDataContext'
import { ProcessingPartnerMaintenanceBottomSheet } from '../../components/BottomSheetComponents/mf-execution/ProcessingPartnerMaintenanceBottomSheet'

export function useProcessingPartnerMaintenanceBottomSheet(screenName: string) {
  const { mfExecutionData } = useMFExecutionContext()
  const { isin } = useMetaDataContext()
  const { openBottomSheet, destroyBottomSheet } = useBottomSheet()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const hasOpenedRef = useRef(false)

  const maintenance = mfExecutionData?.processingPartnerMaintenance

  useEffect(() => {
    if (!maintenance?.title || hasOpenedRef.current) {
      return
    }

    hasOpenedRef.current = true

    const handleClose = () => {
      destroyBottomSheet()
      if (searchParams?.get('from') === 'APP') goBack()
      else navigate(-1)
    }

    openBottomSheet(
      <ProcessingPartnerMaintenanceBottomSheet
        maintenance={maintenance}
        onClose={handleClose}
        ScreenName={screenName}
        fundIsin={isin}
      />,
      undefined,
      { dismissible: false }
    )
  }, [destroyBottomSheet, isin, maintenance, navigate, openBottomSheet, screenName, searchParams])
}
